import { TagTone } from './ui';
import { FastTransferJob } from '../api/models';

// The job state machine, ordered so the UI can render progress and decide
// which action is available next.
export const FAST_TRANSFER_STATES = [
  'DISCOVERED',
  'CONTACT_READY',
  'ELIGIBLE',
  'RESUBMIT_REQUESTED',
  'AUTH_EMAIL_EXPECTED',
  'AUTH_RECEIVED',
  'AUTH_VALIDATED',
  'TERMS_ACCEPTED',
  'FAST_TRANSFER_PENDING',
  'FAST_TRANSFER_ACTIVE',
] as const;

export function stateLabel(state: string): string {
  return state.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}

export function stateTone(state: string): TagTone {
  switch (state) {
    case 'FAST_TRANSFER_ACTIVE':
      return 'success';
    case 'FAST_TRANSFER_PENDING':
    case 'TERMS_ACCEPTED':
    case 'AUTH_VALIDATED':
      return 'accent';
    case 'HUMAN_TASK':
      return 'danger';
    default:
      return 'neutral';
  }
}

// A validated authorization is the precondition for both capture and accept:
// the sidecar has an authorization link to drive only once the router has
// matched and authenticated the registrar's email.
export function hasValidatedAuth(job: FastTransferJob | null | undefined): boolean {
  if (!job) return false;
  return job.state === 'AUTH_RECEIVED' || job.state === 'AUTH_VALIDATED';
}

export function isActive(job: FastTransferJob | null | undefined): boolean {
  return job?.state === 'FAST_TRANSFER_ACTIVE';
}

export function hasApprovedTerms(terms: { active: boolean; approvedAt?: string | null }[]): boolean {
  return terms.some((t) => t.active && !!t.approvedAt);
}

// captureOutcomeMessage turns the sidecar's outcome into a human line.
export function captureOutcomeMessage(outcome: string, error?: string): string {
  switch (outcome) {
    case 'captured':
      return 'Captured the authorization page and terms. Review the terms version below, then approve it.';
    case 'already_active':
      return 'The authorization link was already accepted — this domain is opted in.';
    case 'captcha':
      return 'The panel presented a CAPTCHA. Nothing was submitted; try again later.';
    case 'unexpected_domain':
      return `The authorization page showed a domain outside the expected set${error ? `: ${error}` : ''}.`;
    default:
      return error || `Capture ended with: ${outcome}.`;
  }
}
